import React from "react";
import { useLocation } from "react-router-dom";
import { B2BLayout } from "../../components/b2b/B2BLayout";
import { LeadForm } from "../../components/b2b/LeadForm";
import { useB2BSettings } from "../../lib/b2b";

export default function B2BContact() {
  const loc = useLocation();
  const s = useB2BSettings();
  const defaultPlan = loc.state?.plan || "";
  const selectorAnswers = loc.state?.answers || null;

  return (
    <B2BLayout>
      <section className="mx-auto max-w-3xl px-5 py-12">
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-[#0B1F3A] sm:text-4xl">Richiedi una proposta</h1>
        <p className="mt-3 text-base text-[#0B1F3A]/70">Compila il modulo: la commerciale verifica immobili, dotazioni, zona e copertura, poi prepara una proposta dedicata. Nessun pagamento è richiesto ora.</p>
        {s && !s.launch?.launched && (
          <div className="mt-4 rounded-2xl bg-[#0E7C7B]/10 p-4 text-sm font-semibold text-[#0E7C7B]">Lancio previsto {s.launch?.label}. Raccogliamo già le richieste per preparare la valutazione in anticipo.</div>
        )}
        <div className="mt-8"><LeadForm defaultPlan={defaultPlan} selectorAnswers={selectorAnswers} /></div>
      </section>
    </B2BLayout>
  );
}
